import { Aside as Container } from './aside'
import { List } from './components/list/list'
import { Item } from './components/item/item'

export const Aside = { Container, List, Item }
